import { render, staticRenderFns } from "./AppClamp.vue?vue&type=template&id=0df6e74a&"
import script from "./AppClamp.vue?vue&type=script&lang=js&"
export * from "./AppClamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports